import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalService } from "../global-service";

@Component({
  selector: "app-about",
  templateUrl: "./member-unit.component.html",
  styleUrls: ["./member-unit.component.css"],
})
export class MemberUnitComponent implements OnInit {
  HtmlData: any;
  DocId: any;
  mainData: any;
  memberAssociation: any;
  restultData: any;
  typeList: any = [];
  typeFilter: any = "State";
  constructor(private router: Router,
    public global: GlobalService,
    private route: ActivatedRoute,) {
    this.typeList = [
      { label: "State", value: "All" },
      { label: "Unition", value: "International Judge" },

    ];
  }

  ngOnInit(): void {
    this.getMemberAssociation();
  }

  filterByType(event: any) {
    //  this.name = event.value;
    // this.generateResult();
  }
  UpdateFilter(type: any) {

    this.typeFilter = type;
    this.generateResult();

  }
  generateResult() {
    this.memberAssociation = this.restultData;
    let UnionList=["Akhil Bharatiya Vanwasi Kalyan Ashram","Petroleum Sports Promotion Board","Ordinance Factory Sports Promotion Board",
    "Services Sports Control Board","Railway Sports Promotion Board","Steel Plants Sports Board","All India Police Sports Control Board",
    "ESIC Central Sports Control Board","Railway Sports Promotion Board "];
    if(this.typeFilter=="National"){

      
     this.memberAssociation = this.restultData.filter((obj) => { return  UnionList.includes(obj.memberAssociation.name) });

    }else{
      this.memberAssociation = this.restultData.filter((obj) => { return  !UnionList.includes(obj.memberAssociation.name) });

    }
    
    
   

  }
  getMemberAssociation() {
    const url = this.global.basePath + "common/unionlist";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const array = res[0].json.data;
      this.restultData = array;
      this.generateResult();
    });
  }
}
